import React from 'react';
import PropTypes from 'prop-types';
import Property from '@afosto/app-components-react/Property';

const PickItemProperty = ({ label, value }) => (
  <Property label={label} value={value} valueTypographyProps={{ variant: 'h4' }} />
);

PickItemProperty.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.any,
};

PickItemProperty.defaultProps = {
  value: undefined,
};

export default PickItemProperty;
